module.exports = "/_next/static/images/EngageCustomers@2x-0e701c82eda9260bd2ddcf8ace4a42d0.webp";